import React from 'react'
import { Card } from 'react-bootstrap'
import SearchFoodNutrition from '../nutrition/foodDatabase/searchFoodNutrition';

export default ({ history }) => {
    return (
        <Card className='food-nutrition-card-container'>
            <Card.Header className='class-header'>
                Food Nutrition
            </Card.Header>
            <Card.Body>
                <SearchFoodNutrition afterSearch={() => history.push("/nutrition/food-database")} />
            </Card.Body>
        </Card>
    )
}

